<!--  -->
<template>
  <div class="page">
    <div class="nav-time" @click="enterNow">
      <TimeCount
        v-if="!isFinished"
        :receiveTimeEnd="endTime"
        @timerCountEnd="timerCountEnd"
      ></TimeCount>
      <div class="hstart" v-if="isFinished">
        <span>直播已开始</span>
        <p>立即进入</p>
      </div>
    </div>
    <div class="zhanwei" @click="yulogiin"></div>
    <div class="page-content">
      <div class="lottery-btn">
        您有<span>{{ baseInfo.flipCount || 0 }}次</span> 翻牌机会
      </div>
      <div class="card-info">
        <div class="card-box">
          <div class="card-img" v-for="(item, k) in cardList" :key="k" @click="selectCard(item, k)">
            <img
              :src="item.selected ? item.icon : defaultImg"
              class="letter"
              :class="{ selected: item.selected }"
            />
          </div>
        </div>
      </div>
      <div class="entrance">
        <img
          class="rule"
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-words-mini/correction/rule-icon.png"
          @click="jumpRule"
        />
        <img
          class="record"
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-words-mini/correction/record-icon.png"
          @click="jumpPrize"
        />
      </div>
    </div>

    <TaskList @shareFn="shareFn" @taskFn="taskFn" />
    <RulePop ref="lotteryRule" />
    <RecordPop ref="lotteryPrize" :prizeList="prizeList" :adrdetail="adrdetail" />
    <AnswerPop ref="lotteryAnswer" :currentCardInfo="currentCardInfo" :adrdetail="adrdetail" />
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import {
  reqUsertaskUrl,
  reqFlipUserInfoUrl,
  reqFlipActionUrl,
  reqRecordUrl,
  reqAddressUrl,
} from '@/api/activity/index';
import { replaceHyphens } from '@/utils/tools';
import TimeCount from './component/timeCount.vue';
import TaskList from './component/taskList.vue';
import RulePop from './component/rulePop.vue';
import RecordPop from './component/recordPop.vue';
import AnswerPop from './component/answerPop.vue';

export default {
  components: {
    TaskList,
    RulePop,
    RecordPop,
    AnswerPop,
    TimeCount,
  },
  data() {
    return {
      isApp: this.$root.$data.isApp,
      miniprogram: this.$root.$data.miniprogram,
      availableIcons: [],
      selectedCards: [],
      currentCardInfo: {},
      adrdetail: {},
      baseInfo: {},
      defaultImg:
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/backcard.png',
      cardList: [],
      prizeList: [],
      letterIcons: [
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/A.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/B.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/C.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/D.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/E.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/F.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/G.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/H.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/I.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/J.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/K.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/L.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/M.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/N.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/O.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/P.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/Q.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/R.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/S.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/T.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/U.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/V.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/W.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/X.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/Y.png',
        'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/Z.png',
      ],
      productId: 4166,
      endTime: '2024-10-31 14:00:00',
      isFinished: false,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  created() {
    this.initCardList();
    if (localStorage.getItem('accessToken')) {
      document.addEventListener('visibilitychange', async () => {
        if (document.visibilityState == 'visible') {
          location.reload();
        }
      });
    }
  },
  methods: {
    yulogiin() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      this.$router.push({
        path: `/courseDetail?courseId=${this.productId}`,
      });
    },
    taskFn() {
      this.toLogin();
    },
    enterNow() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      this.$router.push({
        path: `/courseDetail?courseId=${this.productId}`,
      });
    },
    //用户信息
    async getFilpInfo() {
      const { data } = await reqFlipUserInfoUrl();
      this.baseInfo = data || {};
      this.loadSelectedCards();
    },
    //查地址
    async checkAdr() {
      const { data } = await reqAddressUrl();
      this.adrdetail = data || {};
    },
    //中奖记录
    async getrecord() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const { data } = await reqRecordUrl();
      if (!data.length) {
        this.$toast('暂无中奖记录');
      } else {
        this.prizeList = data;
        this.$refs.lotteryPrize.showprizePop = true;
      }
      setTimeout(() => {
        this.$toast.clear();
      }, 1000);
    },
    // 活动规则
    jumpRule() {
      this.$refs.lotteryRule.showPop = true;
    },
    // 奖品记录
    jumpPrize() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      this.getrecord();
    },
    initCardList() {
      // 初始化卡片列表
      for (let i = 0; i < 26; i++) {
        this.cardList.push({ icon: null, selected: false });
      }

      // 打乱字母图片的顺序
      this.availableIcons = this.shuffleArray(this.letterIcons);
    },
    shuffleArray(array) {
      // Fisher-Yates Shuffle 算法
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },

    async selectCard(clickedCard, index) {
      const now = new Date().getTime();
      const end = new Date(replaceHyphens('2024-10-31 12:59:59')).getTime();

      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      if (end >= now) {
        this.$toast('10月31日13:00后再来翻牌吧~');
        return false;
      }

      if (this.baseInfo.flipCount <= 0) {
        this.$toast('当前没有翻牌机会');
        return;
      }
      if (clickedCard.selected) return; // 如果已经被选中，则不执行任何操作

      if (this.availableIcons.length === 0) {
        console.log('所有卡片都已被选中');
        return;
      }

      // 从可用的图标中选择一个
      const chosenIcon = this.availableIcons.pop();
      clickedCard.icon = chosenIcon;
      clickedCard.selected = true;
      // 记录已选中的卡片信息
      this.selectedCards[index] = { icon: chosenIcon };
      let params = {
        letter: chosenIcon.split('/').pop().replace('.png', ''),
        location: index * 1,
      };
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      let res = await reqFlipActionUrl(params);
      if (res.code == 0) {
        this.currentCardInfo = {
          icon: chosenIcon,
          recordId: res.data,
        };
        this.$toast.clear();
        this.$refs.lotteryAnswer.answerPop = true;
        this.getFilpInfo();
      }
    },
    loadSelectedCards() {
      this.baseInfo.userLetterList?.map((t) => {
        t.icon =
          'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/' +
          t.letter.toUpperCase() +
          '.png';
      });
      const savedSelectedCards = this.baseInfo.userLetterList;
      if (savedSelectedCards) {
        this.selectedCards = savedSelectedCards;
        // 恢复已选中的卡片状态
        this.selectedCards.forEach((item) => {
          const indexNum = item.location * 1;
          this.cardList[indexNum]['selected'] = true;
          this.cardList[indexNum].icon = item.icon;
        });
        // 重新初始化 availableIcons，移除已选中的图标
        this.availableIcons = this.letterIcons.filter(
          (icon) => !Object.values(this.selectedCards).some((card) => card.icon === icon),
        );
        this.shuffleArray(this.availableIcons);
      }
    },
    //倒计时结束
    timerCountEnd() {
      this.isFinished = true;
    },
    shareFn() {
      this.getFilpInfo();
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
      this.getFilpInfo();
      this.checkAdr();
    },
    // app 登录回掉
    getLogin(APPSESSION) {
      const cookieToken = APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    // 去登录
    toLogin() {
      if (this.isApp) {
        this.$sendToApp('login', {}, true);
      } else if (this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
          const redirctUrl = encodeURIComponent(
            `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        }
      } else {
        const param = { redirect: 'ark/questionlottery', ...this.$route.query };
        this.$router.push({ path: '/registrationLogin', query: param });
      }
    },
  },

  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
    document.title = '田静讲真题';

    // if (localStorage.getItem('accessToken')) {
    this.getFilpInfo();
    this.checkAdr();
    //  }
  },
};
</script>
<style lang="scss" scoped>
.page {
  background: #f5cacd;

  .zhanwei {
    position: absolute;
    top: 70px;
    left: 0;
    right: 0;
    width: 70%;
    height: 300px;
    margin: 0 auto;
    // background-color: #6633996e;
  }

  .nav-time {
    position: relative;
    width: 100%;
    height: 56px;
    line-height: 56px;
    background: #ff3075;
    border-radius: 0px 0px 12px 12px;

    .hstart {
      span {
        display: block;
        font-weight: 500;
        font-size: 24px;
        color: #ffffff;
        text-align: center;
      }

      p {
        position: absolute;
        right: 30px;
        top: 5px;
        width: 128px;
        height: 46px;
        background: #ffffff;
        border-radius: 23px;
        font-weight: 500;
        font-size: 24px;
        color: #ff3075;
        line-height: 46px;
        text-align: center;
      }
    }
  }

  .page-content {
    width: 100%;
    height: 1360px;
    padding-top: 277px;
    background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/homebg.png')
      no-repeat center top;
    background-size: 100%;
  }

  .lottery-btn {
    font-weight: 500;
    font-size: 30px;
    color: #4c55de;
    padding-top: 210px;
    text-align: center;

    span {
      color: #ff1b51;
    }
  }

  .card-info {
    margin-top: 60px;
    padding: 0 40px 0 50px;

    // min-height: 650px;
    .card-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      min-height: 565px;

      .card-img {
        position: relative;
        margin-right: 10px;
        margin-bottom: 5px;
        border-radius: 20px;

        img {
          width: 88px;
          height: 110px;
          border-radius: 20px;
        }
      }
    }
  }

  .entrance {
    .rule {
      position: fixed;
      top: 144px;
      right: 0;
      z-index: 1;
      width: 72px;
      height: 56px;
    }

    .record {
      position: fixed;
      top: 220px;
      right: 0;
      z-index: 1;
      width: 72px;
      height: 56px;
    }

    .prize {
      position: fixed;
      right: 0;
      bottom: 290px;
      z-index: 1;
      width: 92px;
      height: 110px;
    }
  }
}
</style>
